import { format, parseISO } from 'date-fns';

const calendarExpiryTypes = ['prepaid-card', 'post-office', 'post-office-v2'];

export const formatVoucherExpiry = (expiry, pattern, huggg) => {
  const voucher = huggg?.vouchers?.find((entry) => entry.expiresAt === expiry);
  // These writers encode a calendar deadline as UTC end-of-day. Keep that
  // date when displaying it in timezones where the instant is the next day.
  const isCalendarDeadline =
    calendarExpiryTypes.includes(voucher?.voucherType) &&
    /^\d{4}-\d{2}-\d{2}T23:59:59\.999Z$/.test(expiry);

  return format(
    parseISO(isCalendarDeadline ? expiry.slice(0, 10) : expiry),
    pattern,
  );
};
